/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Failed_To_Copy_Datasource_To_ClipboardInputs */

const en_toast_failed_to_copy_datasource_to_clipboard = /** @type {(inputs: Toast_Failed_To_Copy_Datasource_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to copy datasource to clipboard`)
};

const nl_toast_failed_to_copy_datasource_to_clipboard = /** @type {(inputs: Toast_Failed_To_Copy_Datasource_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiëren van gegevensbron naar klembord mislukt`)
};

/**
* | output |
* | --- |
* | "Failed to copy datasource to clipboard" |
*
* @param {Toast_Failed_To_Copy_Datasource_To_ClipboardInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const toast_failed_to_copy_datasource_to_clipboard = /** @type {((inputs?: Toast_Failed_To_Copy_Datasource_To_ClipboardInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Failed_To_Copy_Datasource_To_ClipboardInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_toast_failed_to_copy_datasource_to_clipboard(inputs)
	return en_toast_failed_to_copy_datasource_to_clipboard(inputs)
});